import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./ViewTable.css";
import { useSelector } from "react-redux";
import ViewComment from "../PopUp/ViewComment";
import VisibilityIcon from "@material-ui/icons/Visibility";
import moment from "moment";

export default function ViewTable() {
  const { commentTableData } = useSelector((store) => store.notesReducer);
  const [content, setContent] = useState("");

  const [openViewNote, setOpenViewNote] = useState(false);

  const handleCloseViewNote = () => {
    setOpenViewNote(false);
  };

  const handleViewComment = async (row) => {
    console.log("data in row::", row);
    await setContent(row?.COMMENT_TEXT);
    setOpenViewNote(true);
  };

  const columns = [
    {
      dataField: "sno",
      text: "Sr.No.",
      headerStyle: {
        backgroundColor: "#230957ff",
        color: "white",
        fontFamily: "Gt-Walsheim-medium, Arial, sans-serif",
        fontSize: "14px",
        fontWeight: "bold",
        textAlign: "center",
        width: "80px",
        padding: "12px 8px",
      },
      style: {
        fontFamily: "Gt-Walsheim-medium, Arial, sans-serif",
        fontSize: "13px",
        textAlign: "center",
        padding: "12px 8px",
        verticalAlign: "middle",
      },
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "COMMENT_TEXT",
      text: "Comment",
      headerStyle: {
        backgroundColor: "#230957ff",
        color: "white",
        fontFamily: "Gt-Walsheim-medium, Arial, sans-serif",
        fontSize: "14px",
        fontWeight: "bold",
        textAlign: "center",
        padding: "12px 15px",
      },
      style: {
        fontFamily: "Gt-Walsheim-medium, Arial, sans-serif",
        fontSize: "13px",
        textAlign: "center",
        padding: "12px 15px",
        wordBreak: "break-word",
        verticalAlign: "middle",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "200px",
      },
      formatter: (cell) => {
        const parser = new DOMParser();
        const text =
          parser.parseFromString(cell, "text/html").body.textContent || "";

        // Show ellipsis after 30 characters
        const truncatedText =
          text.length > 30 ? text.substring(0, 30) + "..." : text;

        return (
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
              maxWidth: "100%",
            }}
          >
            {truncatedText}
          </span>
        );
      },
    },
    {
      dataField: "COMMENTED_AT",
      text: "Date & Time",
      headerStyle: {
        backgroundColor: "#230957ff",
        color: "white",
        fontFamily: "Gt-Walsheim-medium, Arial, sans-serif",
        fontSize: "14px",
        fontWeight: "bold",
        textAlign: "center",
        width: "180px",
        padding: "12px 8px",
      },
      style: {
        fontFamily: "Gt-Walsheim-medium, Arial, sans-serif",
        fontSize: "13px",
        textAlign: "center",
        padding: "12px 8px",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
      },
      formatter: (col, row) => {
        return <>{moment(row.COMMENTED_AT).format("DD/MM/YYYY HH:mm:ss")}</>;
      },
    },
    {
      dataField: "",
      text: "View Comment",
      headerStyle: {
        backgroundColor: "#230957ff",
        color: "white",
        fontFamily: "Gt-Walsheim-medium, Arial, sans-serif",
        fontSize: "14px",
        fontWeight: "bold",
        textAlign: "center",
        width: "180px",
        padding: "12px 8px",
      },
      style: {
        fontFamily: "Gt-Walsheim-medium, Arial, sans-serif",
        fontSize: "13px",
        textAlign: "center",
        padding: "12px 8px",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
      },
      formatter: (cell, row) => {
        return (
          <VisibilityIcon
            fontSize="small"
            onClick={() => handleViewComment(row)}
            style={{ cursor: "pointer" }}
          />
        );
      },
    },
  ];

  return (
    <>
      <div
        className="view-table-container"
        style={{
          overflowY: "scroll",
          height: commentTableData?.length > 7 && "26em",
        }}
      >
        <BootstrapTable
          keyField="COMMENT_ID"
          data={commentTableData}
          columns={columns}
          bordered={false}
          hover
        />
      </div>
      <ViewComment
        openViewNote={openViewNote}
        handleCloseViewNote={handleCloseViewNote}
        content={content}
        setContent={setContent}
      />
    </>
  );
}
